import PrivacyContent from "./privacy_content";
import markdown from "../../_content/privacy/terms.md";

export default function PrivacyTerms() {
  return <PrivacyContent markdown={markdown} />;
}
